export default function modal() {
  MicroModal.init({
    awaitCloseAnimation: true,
    disableScroll: true,
  });
}
